import React from "react";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { Box, Button, Typography } from "@mui/material";
import {
  CancelButton,
  SubmitButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllEvaluationcycle,
  startCycle,
} from "../../../../../redux/features/appraisalSlice";
import { useSnackbar } from "notistack";

const StartCycle = ({ open, setOpen, data }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.appraisal);

  const handleRun = () => {
    const datas = {
      id: data.appraisal_cycle_id,
      type: data.cycle_status === 0 ? 1 : 2,
    };
    dispatch(startCycle(datas)).then((res) => {
      if (res.payload.status === "success") {
        enqueueSnackbar(res.payload.message, { variant: "success" });
        setOpen(false);
        dispatch(getAllEvaluationcycle());
      } else {
        enqueueSnackbar(res.payload.message, { variant: "error" });
      }
    });
  };
  return (
    <GlobalDialog
      open={open}
      setOpen={setOpen}
      title={data.cycle_status === 0 ? "Start Cycle" : "Stop Cycle"}
      closeButton={true}
      fullWidth
      maxWidth={"xs"}
      content={
        <Box>
          <Typography>
            Are you sure you ? want to{" "}
            {data.cycle_status === 0
              ? "run this cycle...!"
              : "stop this cycle...!"}
          </Typography>
        </Box>
      }
      actionButton={
        <>
          <CancelButton size={"small"} action={() => setOpen(false)}>
            Cancel
          </CancelButton>
          <SubmitButton disabled={loading} size={"small"} action={handleRun}>
            {loading
              ? "Please Wait..."
              : data.cycle_status === 0
              ? "Run Cycle"
              : "Stop Cycle"}
          </SubmitButton>
        </>
      }
    />
  );
};

export default StartCycle;
